// ============================================================================
// Heroes Wanted — design tokens for the /heroeswanted campaign popup.
// Ported from the Kaleido web project. Comic / patriotic superhero campaign
// against human trafficking. Scoped to the popup only — not part of the
// global Tailwind theme.
// ============================================================================

export const heroes = {
  color: {
    // Navy family
    ink: "#15235c", // primary navy (page + hero)
    inkDeep: "#0d1840",
    inkPanel: "#1b2b63", // slightly lifted navy for cards on navy
    inkMid: "#33406f",
    slate: "#56618c",
    // Hero red
    red: "#c4162e",
    redDeep: "#a50f24",
    redBright: "#d2202e",
    // Blue accents
    blueLight: "#9cc0ff",
    blueBorder: "rgba(150,180,255,0.35)", // dashed card borders / hairlines
    blue: "#2e60cd",
    // Paper / cream
    paper: "#f3f1ea", // main cream section bg
    paperAlt: "#eeece3",
    paperSoft: "#faf9f4",
    white: "#ffffff",
    // Medal rings
    gold: "#e0b341",
    silver: "#b7c0d0",
    bronze: "#c8884b",
  },
  font: {
    // Substitutes for the licensed originals:
    //  - Allotrope (display) → substitute: Archivo Black.
    //  - Gotham (body/UI) → substitute: Montserrat.
    display: "'Archivo Black', 'Arial Black', system-ui, sans-serif",
    body: "'Montserrat', system-ui, -apple-system, sans-serif",
  },
  radius: {
    button: "4px",
    card: "8px",
    pill: "999px",
  },
  shadow: {
    redGlow: "0 4px 14px rgba(196,22,46,0.4)",
    redGlowStrong: "0 8px 24px rgba(196,22,46,0.5)",
    cardNavy: "0 10px 30px rgba(0,0,0,0.25)",
  },
  letter: {
    overline: "0.28em",
    button: "0.05em",
    label: "0.14em",
  },
};

// The two font families used by the popup.
export const HEROES_FONTS_HREF =
  "https://fonts.googleapis.com/css2?family=Archivo+Black&family=Montserrat:wght@300;400;500;600;700;800;900&display=swap";
